import React from 'react';

const Meetings = () => {
  return <div></div>;
};

export default Meetings;
